import type { WidgetOptions } from "@/shared/types/widgetOptions";

type TooltipOptions = Exclude<
    WidgetOptions,
    | "width"
    | "lock"
    | "check"
    | "hide"
    | "documentMode"
    | "documentTurnPage"
    | "documentName"
    | "mobileEdit"
    | "group"
    | "aiAssistant"
    | "alignChilds"
    | "textBold"
    | "textStrike"
    | "presentationName"
    | "textItalic"
    | "textUnderline"
>;

export const TOOLTIP_CONTENT_KEYS: Record<TooltipOptions, string> = {
    align: "widgetTooltips.align",
    addText: "widgetTooltips.addText",
    arrowEndFirst: "widgetTooltips.arrowEndFirst",
    arrowEnd: "widgetTooltips.arrowEnd",
    border: "widgetTooltips.border",
    clip: "widgetTooltips.clip",
    color: "widgetTooltips.color",
    delete: "widgetTooltips.delete",
    documentDownload: "widgetTooltips.documentDownload",
    documentPreviewPage: "widgetTooltips.documentPreviewPage",
    filter: "widgetTooltips.filter",
    lineType: "widgetTooltips.lineType",
    link: "widgetTooltips.link",
    linkTo: "widgetTooltips.link",
    media: "widgetTooltips.media",
    merge: "widgetTooltips.merge",
    mindMapDirection: "widgetTooltips.mindMapDirection",
    shape: "widgetTooltips.shape",
    stickerColor: "widgetTooltips.color",
    textAlign: "widgetTooltips.textAlign",
    textVerticalAlign: "widgetTooltips.textVerticalAlign",
    textBulleted: "widgetTooltips.textBulleted",
    textColor: "widgetTooltips.color",
    textFont: "widgetTooltips.textFont",
    textSize: "widgetTooltips.textSize",
    unmerge: "widgetTooltips.unmerge",
    textFormat: "widgetTooltips.textFormat",
    contextMenu: "header.menu",
    presentationCreate: "widgetTooltips.presentationCreate",
    frameAspectRatio: "widgetTooltips.frameAspectRatio",
    presentationPlay: "widgetTooltips.presentationPlay",
};
